<template>
  <div>
    <el-collapse accordion>
      <PdvClosedPost ref="prepost" />
      <PdvClosedExternal ref="external" />
      <PdvClosedReverse ref="reverse" />
      <PdvClosedMotoboy ref="motoboy" />
    </el-collapse>
    <PdvClosedPrint ref="printer" @print="printer" @open="$emit('open')" />
    <PdvClosedValues ref="payment" :licence="licence" />
    <div class="bottom clearfix">
      <el-button icon="el-icon-check" type="success" @click="save">Finalizar atendimento</el-button>
      <el-button icon="el-icon-check" type="danger" class="right" @click="$emit('clear')">Cancelar atendimento</el-button>
    </div>
  </div>
</template>

<script>
import PdvClosedExternal from './closed/PdvClosedExternal.vue';
import PdvClosedPost from './closed/PdvClosedPost.vue';
import PdvClosedPrint from './closed/PdvClosedPrint.vue';
import PdvClosedReverse from './closed/PdvClosedReverse.vue';
import PdvClosedValues from './closed/PdvClosedValues.vue';
import PdvClosedMotoboy from './closed/PdvClosedMotoboy.vue';

export default {
  name: "PlpCallClosed",
  props: ["customer", "licence"],
  components: { PdvClosedPost, PdvClosedExternal, PdvClosedReverse, PdvClosedPrint, PdvClosedValues, PdvClosedMotoboy },
  computed: {
    ruleForm() {
      const vm = this;
      return {
        prepost: vm.$refs.prepost.tableData,
        external: vm.$refs.external.tableData,
        reverse: vm.$refs.reverse.tableData,
        printerOptions: vm.$refs.printer.ruleForm,
        motoboy: vm.$refs.motoboy.tableData,
        payment: vm.$refs.payment.paymentData(),
      };
    },
  },
  methods: {
    startup(form) {
      //      this.ruleForm = form;
    },
    setData(id, proof, prepost, external, motoboy) {
      this.$refs.printer.setData(id, proof, prepost, external, motoboy)
    },
    printer(options) {
      if (this.$refs.prepost.tableData.length === 0 &&
        this.$refs.external.tableData.length === 0 &&
        this.$refs.reverse.tableData.length === 0) {
        return this.$message({ type: "error", message: "Não tem nenhuma etiqueta ou comprovante para impressão" });
      }
    },
    clear() {
      const vm = this;
      vm.$refs.prepost.clear();
      vm.$refs.external.clear();
      vm.$refs.reverse.clear();
      vm.$refs.motoboy.clear();
      vm.$refs.printer.clear();
      vm.$refs.payment.clear();
    },
    focus() {
    },
    save() {
      this.$emit('close');
    }
  },
  mounted() {
    const vm = this;
    vm.$bus.$on("pdv.created", (data) => {
      console.log('pdv.created', data, data.type)
      console.log('pdv.created', vm.$refs[data.type])
      vm.$emit('pdvadd');
      setTimeout(() => {
        if (vm.$refs[data.type]) vm.$refs[data.type].add(data);
      }, 300)
      if ((data.type === 'prepost' || data.type === 'motoboy') && vm.$refs.payment) {
        vm.$refs.payment.add(data.value);
      }
    });
    vm.$bus.$on("pdv.removed", (data) => {
      vm.$emit('pdvremove');
      if ((data.type === 'prepost' || data.type === 'motoboy') && vm.$refs.payment) {
        vm.$refs.payment.remove(data.value);
      }
    });

  }
}
</script>